import { useContext } from 'react';
import { Hidden, Skeleton as MaterialSkeleton } from '@mui/material';
import { Grid } from '@mui/system';
import uuid from 'react-uuid';
import { LayoutContextValues } from 'common/types/store';
import LayoutContext from 'context/LayoutContext';
import ScalarIcon from 'icons/Scalar';
import { CrumbIcon, CrumbLink, RootBreadcrumbs, Version } from './styles';
import { BreadcrumbProps } from './types';

const BreadcrumbSkeleton = () => <MaterialSkeleton height={25} variant="text" width={150} />;

const Breadcrumb = ({ icon, title, url, isScalarOwned }: BreadcrumbProps) => {
  if (url) {
    return (
      <CrumbLink className="breadcrumb__item breadcrumb--link" to={url} color="inherit">
        {title ?? <BreadcrumbSkeleton />}
      </CrumbLink>
    );
  }

  if (isScalarOwned) {
    return (
      <Version className="breadcrumb__item" color="textPrimary">
        <CrumbIcon>
          <ScalarIcon />
          {title ?? <BreadcrumbSkeleton />}
        </CrumbIcon>
      </Version>
    );
  }

  return (
    <Version className="breadcrumb__item" color="textPrimary" sx={{ opacity: 1 }}>
      {title ?? <BreadcrumbSkeleton />}
      {title && icon ? icon : ''}
    </Version>
  );
};

const Breadcrumbs = () => {
  const { pageBreadcrumbs } = useContext(LayoutContext) as unknown as LayoutContextValues;

  return (
    <Grid container justifyContent="flex-start" alignItems="center">
      <Hidden mdDown>
        <RootBreadcrumbs id="breadcrumb" separator="/">
          {pageBreadcrumbs?.map(crumb => (
            <Breadcrumb key={`${crumb.title}-${uuid()}`} {...crumb} />
          ))}
        </RootBreadcrumbs>
      </Hidden>
    </Grid>
  );
};

export default Breadcrumbs;
